import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const itamAiInsightsPreviewRoute: InvariantJiraRoute = {
	name: 'itam-ai-insights-preview',
	path: '/jira/itam/:practice/ai-insights-preview/embed',
	exact: true,
};
